import {OAUTH2_CONFIGS, OAUTH1_CONFIGS} from "../../../Constants";
import {OAuth2Client} from "./OAuth2Client";
import {OAuth1Client} from "./OAuth1Client";


export class SocialAccountsManager {
    static init() {
        if (!this.instance) {
            this.instance = new this();
        }
    }

    constructor() {
        this.initClients();
    }

    initClients() {
        this.clientsByName = {};
        Object.keys(OAUTH2_CONFIGS).forEach(clientName => {
            const oauth2Client = OAUTH2_CONFIGS[clientName];
            this.clientsByName[clientName] = new OAuth2Client(
                oauth2Client.clientId,
                location.origin + oauth2Client.redirectUri,
                oauth2Client.authServerUrl,
                oauth2Client.loginEndpoint
            );
            if (Object.prototype.hasOwnProperty.call(oauth2Client, "scope")) {
                this.clientsByName[clientName].setScope(oauth2Client.scope);
            }
            if (Object.prototype.hasOwnProperty.call(oauth2Client, "responseType")) {
                this.clientsByName[clientName].setResponseType(oauth2Client.responseType);
            }
        });

        Object.keys(OAUTH1_CONFIGS).forEach(clientName => {
            const oauth1Client = OAUTH1_CONFIGS[clientName];
            this.clientsByName[clientName] = new OAuth1Client(
                oauth1Client.clientId,
                oauth1Client.authServerUrl,
                oauth1Client.loginEndpoint,
                oauth1Client.requestTokenEndpoint
            );
        });
    }

    // Try to authenticate the user. If it is a new account, then request for Terms accept.
    handleRedirectAuthInfo(data) {
        // OAuth2
        if (data.code && data.clientName) {
            this.clientsByName[data.clientName].handleLoginResponse(data.code);
        }

        // OAuth1
        if (data.oauth_token && data.oauth_verifier) {
            this.clientsByName[data.clientName].handleLoginResponse(data.oauth_token, data.oauth_verifier);
        }
    }

    static getClientByName(clientName) {
        return this.instance.clientsByName[clientName];
    }

    static getInstance() {
        return this.instance;
    }
}

SocialAccountsManager.init();
